import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  isLoading: boolean;
}

const initialState: UIState = {
  isLoading: true // 초기에는 로딩 중 상태
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    }
  }
});

export const { setLoading } = uiSlice.actions;
export default uiSlice.reducer;